import React from 'react'

const SortIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='14'
    viewBox='0 0 12 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.33366 7.66683V2.8835L1.61699 4.60016L0.666992 3.66683L4.00033 0.333496L7.33366 3.66683L6.38366 4.60016L4.66699 2.8835V7.66683H3.33366ZM8.00033 13.6668L4.66699 10.3335L5.61699 9.40016L7.33366 11.1168V6.3335H8.66699V11.1168L10.3837 9.40016L11.3337 10.3335L8.00033 13.6668Z'
      fill='currentColor'
    />
  </svg>
)

export default SortIcon
